function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 95"
}, props), React.createElement("path", {
  d: "M67.952 70.991l1.923-2.662c4.323-5.9.552-14.761-6.265-14.726-6.818.036-10.518 8.932-6.145 14.79l17.546 23.493L80 86.916l-18.256-24.14c-1.892-2.527-2.266-5.623-1.543-8.328M52.526 92L63.7 76.749",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M48.61 31.11l-1.606-1.42c-2.368-2.094-4.17-4.217-4.183-7.59L42.738 2M30.233 31.202l1.594-1.441c2.348-2.116 4.132-4.26 4.12-7.633l-.083-20.1",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M48.61 31.11s.463-2.52.913-3.884c1.099-3.301 4.755-4.395 7.16-2.13 4.514 4.253 11.427 12.17 15.96 24.013 0 0 1.047 2.69 1.662 5.14M30.233 31.202s-.482-2.52-.946-3.87c-1.123-3.286-4.792-4.344-7.179-2.051-8.049 7.718-23.734 27.35-19.348 60.116.457 3.394 3.694 5.36 6.5 3.955 4.228-2.123 10.512-5.531 17.228-10.104 3.428-2.328 5.637-6.383 5.922-10.856.381-6.035.686-15.158-.025-24.147-.127-3.06.857-5.623 3.003-7.519 1.187-1.05 2.615-1.576 4.043-1.583 1.428 0 2.863.511 4.056 1.54 2.165 1.875 3.168 4.431 3.066 7.491-.64 8.989-.253 18.112.172 24.147.317 4.473 2.564 8.5 6.011 10.8.705.468 1.403.923 2.095 1.37M8.505 44.345s1.6 5.09 11.28 5.04M5.324 52.424c1.365 1.3 5.878 4.85 14.492 4.807",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})));